import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/B1';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得繳別變更條款說明
export function getAgreeTermsB1() {
    return get(`${url}/getAgreeTerms`);
};

// 繳別變更條款同意
export function postAgreeB1() {
    return post(`${url}/agree`);
};

// 取得繳別選單
export function getMopInfoB1() {
    return get(`${url}/mopInfo`);
};

// 取得先前繳別變更記錄
export function getInfoB1() {
    return get(`${url}/info`);
}

/**
 * sumbit
 * @param {Object} data
 */
export function submitB1(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
